import type { SpriteDefinition } from '@/render/spriteBaker';
import type { EnemyId } from '@/data/enemies';
import { PALETTE } from '@/sprites/palette';

/**
 * Enemy art, 16x16 on the same grid as everything else.
 *
 * Two frames each, alternated on a timer rather than per-entity state, so a
 * field of moths does not need a field of animation clocks.
 */

const MOTH_A: readonly string[] = [
  '................',
  '................',
  '................',
  '....N......N....',
  '...NNN....NNN...',
  '..NNNNN..NNNNN..',
  '..NNNNNeeNNNNN..',
  '..NNNNNeeNNNNN..',
  '...NNNN..NNNN...',
  '....NN....NN....',
  '.......ee.......',
  '.......ee.......',
  '................',
  '................',
  '................',
  '................',
];

const MOTH_B: readonly string[] = [
  '................',
  '................',
  '................',
  '................',
  '.....N....N.....',
  '....NNN..NNN....',
  '...NNNNeeNNNN...',
  '...NNNNeeNNNN...',
  '....NNN..NNN....',
  '.....N....N.....',
  '.......ee.......',
  '.......ee.......',
  '................',
  '................',
  '................',
  '................',
];

const GRUB_A: readonly string[] = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '.....iiiii......',
  '....iiiiiii.....',
  '...iiIiiiIii....',
  '...iiiiiiiii....',
  '....iiiiiii.....',
  '.....iiiii......',
  '......III.......',
  '................',
  '................',
  '................',
  '................',
];

const GRUB_B: readonly string[] = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '......iiii......',
  '....iiiiiiii....',
  '...iiIiiiiIi....',
  '...iiiiiiiii....',
  '....iiiiiiii....',
  '......iiii......',
  '.....III........',
  '................',
  '................',
  '................',
  '................',
];

export const ENEMY_SPRITES = {
  'blightMoth-0': { name: 'blight-moth-0', rows: MOTH_A, palette: PALETTE },
  'blightMoth-1': { name: 'blight-moth-1', rows: MOTH_B, palette: PALETTE },
  'rootGrub-0': { name: 'root-grub-0', rows: GRUB_A, palette: PALETTE },
  'rootGrub-1': { name: 'root-grub-1', rows: GRUB_B, palette: PALETTE },
} as const satisfies Record<`${EnemyId}-${0 | 1}`, SpriteDefinition>;

export type EnemySpriteKey = keyof typeof ENEMY_SPRITES;

export function enemySpriteKey(id: EnemyId, frame: 0 | 1): EnemySpriteKey {
  return `${id}-${frame}`;
}
